import { z } from "zod";

export const SalaryScaleFormSchema = z.object({
  code: z.string().trim().optional(),
  name: z.string().trim().min(1),
  roundingMode: z.coerce.number().min(0),
  roundingStep: z.coerce.number().min(1),
  description: z.string().trim().optional().nullable(),
  effectiveDate: z.coerce.date(),
  expirationDate: z.coerce.date().optional().nullable(),
});

export const SalaryGradeFormSchema = z.object({
  code: z.string().trim().min(1),
  name: z.string().trim().min(1),
  description: z.string().trim().optional().nullable(),
  order: z.coerce.number().min(1),
});

export const SalaryStepFormSchema = z.object({
  level: z.coerce.number().int().min(1).max(12),
  increasePercent: z.coerce.number().min(0),
});

export const SyncProfileFormSchema = z.object({
  payrollItemId: z.coerce.number().min(1, "Vui lòng chọn tham số lương"),
});
